import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://dessywedding.site";
const DEFAULT_IMG = `${SITE_URL}/brand/dwg-logo.png`;

export default function Seo({ title, description, path = "/", image, jsonLd }) {
  const fullTitle = title ? `${title} | Dessy Wedding Group` : "Dessy Wedding Group — Wedding Organizer & MUA Garut Bandung";
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMG;
  useEffect(() => {
    document.querySelectorAll("meta[data-static-seo]").forEach((m) => m.remove());
  }, []);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
